import React, { PropsWithChildren } from "react";

export type LayoutContextType = {
    baseUiUrl?: string;
};

function getDefaultLayout(): LayoutContextType {
    return {
        baseUiUrl: undefined,
    };
}

export const LayoutContext = React.createContext<LayoutContextType>(getDefaultLayout());

export const useLayoutContext = () => React.useContext(LayoutContext);

export const LayoutContextProvider = (
    props: PropsWithChildren<{
        layout: LayoutContextType;
    }>
) => {
    return <LayoutContext.Provider value={props.layout}>{props.children}</LayoutContext.Provider>;
};
